import React, { lazy, useEffect } from "react";
import { usePluginConfig } from "./hooks/usePluginConfig";
import { LabelsProvider } from "./context/LabelsContext";
import { ClubProvider } from "./context/ClubContext";
import { ConfigProvider } from "./context/ConfigContext";
import "./App.scss";
import { UserProvider } from "./context/UserContext";
import { AuthProvider } from "./context/AuthContext";
import { useClub } from "./hooks/useClub";
import { AuthMode, PluginConfig } from "./models/plugin-config";
import { useClubContext } from "./context/ClubContext";
import { useUserContext } from "./context/UserContext";
import { Club } from "./models/club";
import { User } from "./models/user";
const RegistrationForm = lazy(
	() => import("./components/Registration/RegistrationForm"),
);
const AuthTriggerButton = lazy(
	() => import("./components/Authentication/AuthTriggerButton"),
);

type CallbackBridgeProps = {
	getClub?: (club: Club | null) => void;
	getUser?: (user: User | null) => void;
};

const CallbackBridge: React.FC<CallbackBridgeProps> = ({
	getClub,
	getUser,
}) => {
	const { club } = useClubContext();
	const { user } = useUserContext();

	useEffect(() => {
		getClub?.(club);
	}, [club, getClub]);

	useEffect(() => {
		getUser?.(user);
	}, [user, getUser]);

	return null;
};
export type AppProps = {
	element?: HTMLElement | null;
	idx?: number;
	config?: PluginConfig;
	authMode?: AuthMode;
	getClub?: (club: Club | null) => void;
	getUser?: (user: User | null) => void;
	children?: React.ReactNode;
};
export const App: React.FC<AppProps> = ({
	element,
	config,
	authMode,
	getClub,
	getUser,
	children,
}: AppProps) => {
	const {
		config: resolvedConfig,
		authMode: resolvedAuthMode,
		setAuthMode,
	} = usePluginConfig(element ?? null, {
		config,
		authMode,
	});
	const { club } = useClub(resolvedConfig);

	useEffect(() => {
		console.log(
			`club-plugin version: ${__CLUB_PLUGIN_VERSION__} | env: ${__CLUB_PLUGIN_ENV__}`,
		);
	}, []);

	if (!resolvedConfig || !club) return null;

	return (
		<main id='simplex-club-plugin'>
			<ConfigProvider
				config={resolvedConfig}
				authMode={resolvedAuthMode}
				setAuthMode={setAuthMode}
			>
				<ClubProvider club={club}>
					<LabelsProvider>
						<UserProvider>
							<AuthProvider>
								{resolvedAuthMode === "registration" ? (
									<RegistrationForm />
								) : (
									<AuthTriggerButton />
								)}
								<CallbackBridge
									getClub={getClub}
									getUser={getUser}
								/>
								{children}
							</AuthProvider>
						</UserProvider>
					</LabelsProvider>
				</ClubProvider>
			</ConfigProvider>
		</main>
	);
};
